module.exports = __webpack_public_path__ + "static/img/bg.a11fe2d9.png";